<script setup lang="ts">
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/budget',
    icon: '/public/icons/icon-budget.svg',
    label: 'Budget',
    exact: true,
    initialSidebarOpen: true
  },
  {
    to: '/front/budget/previsions',
    icon: '/public/icons/icon-budget-prevision.svg',
    label: 'Prévisions',
    initialSidebarOpen: true
  },
  {
    to: '/front/budget/categories',
    icon: '/public/icons/icon-plan.svg',
    label: 'Catégories',
    initialSidebarOpen: true
  }
]
</script>

<template>
  <SectionSidebar :menu-items="menuItems" />

  <section class="app-section">
    <div class="page-space-25" />
    <router-view />
  </section>
</template>
